import {IHttpService} from "angular";
import {IsoDate} from "../../pseudo-types/DateTypes";
import {BankAccountTransactionRecords} from "../types/BankAccountTransactionRecord";
import {AccountId} from "../types/AccountRecord";

export class BankAccountTransactionsService {

    public static readonly id = "bankAccountTransactionsService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async list(accountId: AccountId,
                      fromDate: IsoDate,
                      toDate: IsoDate | null): Promise<BankAccountTransactionRecords> {
        const url = `/tradefloor/api/bank-account-transactions/${accountId}`;
        const params = { fromDate, toDate };
        const response = await this.$http.get<BankAccountTransactionRecords>(url, {params});
        return response.data;
    }
}
